import './Draggable.svelte.css';
/* src/components/Draggable.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	action_destroyer,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_animation,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	fix_and_outro_and_destroy_block,
	fix_position,
	group_outros,
	init,
	insert,
	is_function,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_store_value,
	space,
	toggle_class,
	transition_in,
	transition_out,
	update_keyed_each
} from "../../_snowpack/pkg/svelte/internal.js";

import { flip } from "../../_snowpack/pkg/svelte/animate.js";
import { dndzone } from "../../_snowpack/pkg/svelte-dnd-action.js";
import { AreaTitle, CategoryTitle, CreateCategoryForm, CountText } from "./index.js";

import {
	svelteAnimateOptions,
	dndOptions,
	dndFlipOption,
	reorderItems,
	addGroupedCategoriesToAreas
} from "../utils/dnd-helpers.js";

import { areas, groupedCategories } from "../stores/index.js";
import { MAX_CATEGORY_COUNT } from "../data/constants.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[13] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[16] = list[i];
	return child_ctx;
}

// (73:8) {#if area?.items}
function create_if_block_1(ctx) {
	let each_blocks = [];
	let each_1_lookup = new Map();
	let each_1_anchor;
	let current;
	let each_value_1 = /*area*/ ctx[13].items;
	const get_key = ctx => /*category*/ ctx[16].id;

	for (let i = 0; i < each_value_1.length; i += 1) {
		let child_ctx = get_each_context_1(ctx, each_value_1, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block_1(key, child_ctx));
	}

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*isDraggingCategory, dndItems*/ 5) {
				each_value_1 = /*area*/ ctx[13].items;
				group_outros();
				for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].r();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_1, each_1_lookup, each_1_anchor.parentNode, fix_and_outro_and_destroy_block, create_each_block_1, each_1_anchor, get_each_context_1);
				for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].a();
				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d(detaching);
			}

			if (detaching) detach(each_1_anchor);
		}
	};
}

// (74:10) {#each area.items as category (category.id)}
function create_each_block_1(key_1, ctx) {
	let div;
	let categorytitle;
	let t;
	let rect;
	let stop_animation = noop;
	let current;

	categorytitle = new CategoryTitle({
			props: {
				category: /*category*/ ctx[16],
				area: /*area*/ ctx[13]
			}
		});

	return {
		key: key_1,
		first: null,
		c() {
			div = element("div");
			create_component(categorytitle.$$.fragment);
			t = space();
			attr(div, "class", "jd-cat jd-item-in-list svelte-141ak1w");
			toggle_class(div, "is-dragging", /*isDraggingCategory*/ ctx[2]);
			this.first = div;
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(categorytitle, div, null);
			append(div, t);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const categorytitle_changes = {};
			if (dirty & /*dndItems*/ 1) categorytitle_changes.category = /*category*/ ctx[16];
			if (dirty & /*dndItems*/ 1) categorytitle_changes.area = /*area*/ ctx[13];
			categorytitle.$set(categorytitle_changes);

			if (dirty & /*isDraggingCategory*/ 4) {
				toggle_class(div, "is-dragging", /*isDraggingCategory*/ ctx[2]);
			}
		},
		r() {
			rect = div.getBoundingClientRect();
		},
		f() {
			fix_position(div);
			stop_animation();
		},
		a() {
			stop_animation();
			stop_animation = create_animation(div, rect, flip, svelteAnimateOptions);
		},
		i(local) {
			if (current) return;
			transition_in(categorytitle.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(categorytitle.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(categorytitle);
		}
	};
}

// (85:6) {#if area?.items?.length < MAX_CATEGORY_COUNT}
function create_if_block(ctx) {
	let div;
	let createcategoryform;
	let t;
	let counttext;
	let current;
	createcategoryform = new CreateCategoryForm({ props: { areaId: /*area*/ ctx[13].id } });
	createcategoryform.$on("created", /*scrollToBottom*/ ctx[7]);

	counttext = new CountText({
			props: {
				items: /*area*/ ctx[13].items,
				countType: "CATEGORY"
			}
		});

	return {
		c() {
			div = element("div");
			create_component(createcategoryform.$$.fragment);
			t = space();
			create_component(counttext.$$.fragment);
			attr(div, "class", "jd-create-container");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(createcategoryform, div, null);
			append(div, t);
			mount_component(counttext, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const createcategoryform_changes = {};
			if (dirty & /*dndItems*/ 1) createcategoryform_changes.areaId = /*area*/ ctx[13].id;
			createcategoryform.$set(createcategoryform_changes);
			const counttext_changes = {};
			if (dirty & /*dndItems*/ 1) counttext_changes.items = /*area*/ ctx[13].items;
			counttext.$set(counttext_changes);
		},
		i(local) {
			if (current) return;
			transition_in(createcategoryform.$$.fragment, local);
			transition_in(counttext.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(createcategoryform.$$.fragment, local);
			transition_out(counttext.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(createcategoryform);
			destroy_component(counttext);
		}
	};
}

// (59:2) {#each dndItems as area (area.id)}
function create_each_block(key_1, ctx) {
	let div1;
	let areatitle;
	let t0;
	let div0;
	let div0_data_area_id_value;
	let dndzone_action;
	let t1;
	let t2;
	let rect;
	let stop_animation = noop;
	let current;
	let mounted;
	let dispose;
	areatitle = new AreaTitle({ props: { area: /*area*/ ctx[13] } });
	let if_block0 = /*area*/ ctx[13]?.items && create_if_block_1(ctx);

	function consider_handler(...args) {
		return /*consider_handler*/ ctx[10](/*area*/ ctx[13], ...args);
	}

	function finalize_handler(...args) {
		return /*finalize_handler*/ ctx[11](/*area*/ ctx[13], ...args);
	}

	let if_block1 = /*area*/ ctx[13]?.items?.length < MAX_CATEGORY_COUNT && create_if_block(ctx);

	return {
		key: key_1,
		first: null,
		c() {
			div1 = element("div");
			create_component(areatitle.$$.fragment);
			t0 = space();
			div0 = element("div");
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			attr(div0, "class", "jd-area__content svelte-141ak1w");
			attr(div0, "data-area-id", div0_data_area_id_value = /*area*/ ctx[13].id);
			attr(div1, "class", "jd-area svelte-141ak1w");
			toggle_class(div1, "is-dragging", /*isDraggingArea*/ ctx[1] || /*isDraggingCategory*/ ctx[2]);
			this.first = div1;
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			mount_component(areatitle, div1, null);
			append(div1, t0);
			append(div1, div0);
			if (if_block0) if_block0.m(div0, null);
			append(div1, t1);
			if (if_block1) if_block1.m(div1, null);
			append(div1, t2);
			current = true;

			if (!mounted) {
				dispose = [
					action_destroyer(dndzone_action = dndzone.call(null, div0, {
						...dndFlipOption,
						items: /*area*/ ctx[13].items,
						dropFromOthersDisabled: /*area*/ ctx[13]?.items.length >= MAX_CATEGORY_COUNT
					})),
					listen(div0, "consider", consider_handler),
					listen(div0, "finalize", finalize_handler)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const areatitle_changes = {};
			if (dirty & /*dndItems*/ 1) areatitle_changes.area = /*area*/ ctx[13];
			areatitle.$set(areatitle_changes);

			if (/*area*/ ctx[13]?.items) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*dndItems*/ 1) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div0, null);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*dndItems*/ 1 && div0_data_area_id_value !== (div0_data_area_id_value = /*area*/ ctx[13].id)) {
				attr(div0, "data-area-id", div0_data_area_id_value);
			}

			if (dndzone_action && is_function(dndzone_action.update) && dirty & /*dndItems*/ 1) dndzone_action.update.call(null, {
				...dndFlipOption,
				items: /*area*/ ctx[13].items,
				dropFromOthersDisabled: /*area*/ ctx[13]?.items.length >= MAX_CATEGORY_COUNT
			});

			if (/*area*/ ctx[13]?.items?.length < MAX_CATEGORY_COUNT) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*dndItems*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (dirty & /*isDraggingArea, isDraggingCategory*/ 6) {
				toggle_class(div1, "is-dragging", /*isDraggingArea*/ ctx[1] || /*isDraggingCategory*/ ctx[2]);
			}
		},
		r() {
			rect = div1.getBoundingClientRect();
		},
		f() {
			fix_position(div1);
			stop_animation();
		},
		a() {
			stop_animation();
			stop_animation = create_animation(div1, rect, flip, svelteAnimateOptions);
		},
		i(local) {
			if (current) return;
			transition_in(areatitle.$$.fragment, local);
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(areatitle.$$.fragment, local);
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(areatitle);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let section;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let dndzone_action;
	let current;
	let mounted;
	let dispose;
	let each_value = /*dndItems*/ ctx[0];
	const get_key = ctx => /*area*/ ctx[13].id;

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	return {
		c() {
			section = element("section");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(section, "class", "jd-outer svelte-141ak1w");
		},
		m(target, anchor) {
			insert(target, section, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(section, null);
			}

			current = true;

			if (!mounted) {
				dispose = [
					action_destroyer(dndzone_action = dndzone.call(null, section, {
						...dndOptions,
						items: /*dndItems*/ ctx[0]
					})),
					listen(section, "consider", /*handleConsiderAreas*/ ctx[3]),
					listen(section, "finalize", /*handleFinalizeAreas*/ ctx[4])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*isDraggingArea, isDraggingCategory, dndItems, scrollToBottom, MAX_CATEGORY_COUNT, dndFlipOption, handleConsiderCategories, handleFinalizeCategories*/ 231) {
				each_value = /*dndItems*/ ctx[0];
				group_outros();
				for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].r();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, section, fix_and_outro_and_destroy_block, create_each_block, null, get_each_context);
				for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].a();
				check_outros();
			}

			if (dndzone_action && is_function(dndzone_action.update) && dirty & /*dndItems*/ 1) dndzone_action.update.call(null, {
				...dndOptions,
				items: /*dndItems*/ ctx[0]
			});
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $areas;
	let $groupedCategories;
	component_subscribe($$self, areas, $$value => $$invalidate(8, $areas = $$value));
	component_subscribe($$self, groupedCategories, $$value => $$invalidate(9, $groupedCategories = $$value));
	
	let dndItems = []; // passed to dndZone as props
	let areaContentEl; // for scroll to bottom when new area is added
	let isDraggingArea = false; // for styling
	let isDraggingCategory = false;

	const handleConsiderAreas = e => {
		$$invalidate(1, isDraggingArea = true);
		set_store_value(areas, $areas = e.detail.items, $areas);
	};

	const handleFinalizeAreas = e => {
		$$invalidate(1, isDraggingArea = false);
		const updatedAreas = reorderItems(e.detail.items);
		set_store_value(areas, $areas = updatedAreas, $areas);
	};

	const handleConsiderCategories = (areaId, e) => {
		$$invalidate(2, isDraggingCategory = true);
		const catIndex = dndItems.findIndex(c => c.id === areaId);
		$$invalidate(0, dndItems[catIndex].items = e.detail.items, dndItems);
		$$invalidate(0, dndItems = [...dndItems]);
	};

	const handleFinalizeCategories = (areaId, e) => {
		$$invalidate(2, isDraggingCategory = false);

		// Get this category's parent area
		const catIndex = dndItems.findIndex(c => c.id === areaId);

		const parentArea = dndItems[catIndex];

		// @ts-ignore
		set_store_value(groupedCategories, $groupedCategories[parentArea.id] = reorderItems(e.detail.items), $groupedCategories);
	};

	// Scroll to area bottom when new category is added.
	// Note: Can't use svelte bind:this because element is in "each" block.
	const scrollToBottom = e => {
		const ITEM_H = 48;
		const areaId = e.detail.areaId;
		if (areaId) areaContentEl = document.querySelector(`[data-area-id="${areaId}"]`);

		setTimeout(
			() => {
				if (areaContentEl) areaContentEl.scrollTop = areaContentEl.scrollHeight + ITEM_H;
			},
			50
		);
	};

	const consider_handler = (area, e) => handleConsiderCategories(area.id, e);
	const finalize_handler = (area, e) => handleFinalizeCategories(area.id, e);

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$areas, $groupedCategories*/ 768) {
			// = = =
			$: {
				$$invalidate(0, dndItems = addGroupedCategoriesToAreas($areas, $groupedCategories));
			}
		}
	};

	return [
		dndItems,
		isDraggingArea,
		isDraggingCategory,
		handleConsiderAreas,
		handleFinalizeAreas,
		handleConsiderCategories,
		handleFinalizeCategories,
		scrollToBottom,
		$areas,
		$groupedCategories,
		consider_handler,
		finalize_handler
	];
}

class Draggable extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Draggable;